<template>
  <div class="kingster-body-outer-wrapper  mm-page mm-slideout" id="mm-0">
    <div class="kingster-body-wrapper clearfix  kingster-with-frame">
      <!-- <div class="kingster-sticky-menu-placeholder" style="height: 98px;"></div> -->

      <div
        class="kingster-page-title-wrap  kingster-style-custom kingster-left-align"
        id="div_983a_0"
        :style="
          'background-image: url(' +
            require('@/assets/images/template4/about-title-bg.jpg') +
            ')'
        "
      >
        <div class="kingster-header-transparent-substitute"></div>
        <div class="kingster-page-title-overlay"></div>
        <div class="kingster-page-title-bottom-gradient"></div>
        <div class="kingster-page-title-container kingster-container">
          <div
            class="kingster-page-title-content kingster-item-pdlr"
            id="div_983a_1"
          >
            <div class="kingster-page-caption" id="div_983a_2">
              Know Us Better
            </div>
            <h1 class="kingster-page-title" id="h1_983a_0">Sambutan</h1>
          </div>
        </div>
      </div>
      <div class="kingster-breadcrumbs">
        <div class="kingster-breadcrumbs-container kingster-container">
          <div class="kingster-breadcrumbs-item kingster-item-pdlr">
            <span property="itemListElement" typeof="ListItem"
              ><router-link
                :to="`/${meta.preview}`"
                property="item"
                typeof="WebPage"
                title="Go to Kingster."
                class="home"
                ><span property="name">Home</span></router-link
              >
              <meta property="position" content="1" /> </span
            >&gt;<span property="itemListElement" typeof="ListItem"
              ><span property="name"> Sambutan Kepala Sekolah </span>
              <meta property="position" content="2" />
            </span>
          </div>
        </div>
      </div>
      <div class="kingster-page-wrapper" id="kingster-page-wrapper">
        <div class="gdlr-core-page-builder-body">
          <div class="gdlr-core-pbf-wrapper " id="div_983a_3">
            <div class="gdlr-core-pbf-background-wrap"></div>
            <div class="gdlr-core-pbf-wrapper-content gdlr-core-js ">
              <div
                class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container"
              >
                <div
                  class="gdlr-core-pbf-column gdlr-core-column-20 gdlr-core-column-first"
                >
                  <div
                    class="gdlr-core-pbf-column-content-margin gdlr-core-js "
                  >
                    <div
                      class="gdlr-core-pbf-column-content clearfix gdlr-core-js "
                    >
                      <div class="gdlr-core-pbf-element">
                        <div
                          class="gdlr-core-title-item gdlr-core-item-pdb clearfix  gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr"
                          id="div_983a_4"
                        >
                          <div class="gdlr-core-title-item-title-wrap clearfix">
                            <h3
                              class="gdlr-core-title-item-title gdlr-core-skin-title "
                              id="h3_983a_0"
                            >
                              Sambutan Kepala Sekolah
                            </h3>
                          </div>
                        </div>
                      </div>
                      <div class="gdlr-core-pbf-element">
                        <div
                          class="gdlr-core-divider-item gdlr-core-divider-item-normal gdlr-core-item-pdlr gdlr-core-left-align"
                        >
                          <div
                            class="gdlr-core-divider-container"
                            id="div_983a_5"
                          >
                            <div
                              class="gdlr-core-divider-line gdlr-core-skin-divider"
                              id="div_983a_6"
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-column gdlr-core-column-40">
                  <div
                    class="gdlr-core-pbf-column-content-margin gdlr-core-js "
                  >
                    <div
                      class="gdlr-core-pbf-column-content clearfix gdlr-core-js "
                    >
                      <div class="gdlr-core-pbf-element">
                        <div
                          class="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align"
                        >
                          <div
                            class="gdlr-core-text-box-item-content"
                            id="div_983a_7"
                            data-aos="fade-in"
                            data-aos-duration="3000"
                            data-aos-delay="300"
                            v-html="foreword.body"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["foreword", "meta"],
};
</script>
